import { render, staticRenderFns } from "./index.vue?vue&type=template&id=972b6ce2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=972b6ce2&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=972b6ce2&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972b6ce2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('972b6ce2')) {
      api.createRecord('972b6ce2', component.options)
    } else {
      api.reload('972b6ce2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=972b6ce2&scoped=true", function () {
      api.rerender('972b6ce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basicData/postalCodeManagement/index.vue"
export default component.exports